import { render, staticRenderFns } from "./backdrop.vue?vue&type=template&id=22a700da"
import script from "./backdrop.vue?vue&type=script&lang=js"
export * from "./backdrop.vue?vue&type=script&lang=js"
import style0 from "./backdrop.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports